import { Stack } from "@mui/material";
import React from "react";
import Testing from "./Testing";
import MobileHeroSection from "./MobileHeroSection";
import BadgeSection from "./BadgeSection";
import Testing1 from "./Testing1";
import MobileHeroScroll from "./MobileHeroScroll";

const MainHeroSection = () => {
  return (
    <Stack>
      <Stack
        sx={{
          display: {
            xl: "none",
            lg: "none",
            md: "none",
            sm: "none",
            xs: "flex",
          },
        }}
      >
        <MobileHeroSection />
        {/* <BadgeSection /> */}
        <MobileHeroScroll />
      </Stack>
      <Stack
        sx={{
          display: {
            xl: "flex",
            lg: "flex",
            md: "flex",
            sm: "flex",
            xs: "none",
          },
          // border: "2px solid green",
        }}
      >
        {/* <Testing /> */}
        <Testing1 />
      </Stack>
    </Stack>
  );
};

export default MainHeroSection;
